<template lang="pug">
  payout-form-group
    template(v-slot:labelinner)
      i.glyphicon.glyphicon-question-sign.hint-panel-question-icon
    .form-control-space
      payout-toggable-hint-panel(:heading='heading' :link-text='linkText')
        slot

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutToggableHintPanel from "@/components/forms/payout/PayoutToggableHintPanel.vue";

@Component({
  name: "PayoutToggableHintPanelFormGroup",
  components: {PayoutToggableHintPanel, PayoutFormGroup}
})
export default class PayoutToggableHintPanelFormGroup extends Vue {
  @Prop({default: null})
  heading: string | null

  @Prop({default: null})
  linkText: string | null
}
</script>

<style scoped>

</style>
